import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get next receipt number
export const getNextReceiptNumber = async (businessId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Receipt/get-next-receipt-number`,
      { BusinessId: businessId },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting next receipt number:", error);
    throw error;
  }
};

// Get customer credit invoices
export const getCustomerCreditInvoices = async (customerId, businessId, branchId = null) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Receipt/get-customer-credit-invoices`,
      {
        CustomerId: customerId,
        BusinessId: businessId,
        BranchId: branchId
      },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting customer credit invoices:", error);
    throw error;
  }
};

// Save receipt
export const saveReceipt = async (receiptData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Receipt/save-receipt`,
      receiptData,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving receipt:", error);
    throw error;
  }
};

// Get receipts with filters and pagination
export const getReceipts = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Receipt/get-receipts`,
      filter,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting receipts:", error);
    throw error;
  }
};

// Get receipt by ID
export const getReceiptById = async (receiptId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/Receipt/get-receipt-by-id/${receiptId}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting receipt by ID:", error);
    throw error;
  }
};

